import React from 'react';
import cx from 'classnames';

export type GuidesToggleCardProps = {
    children?: React.ReactNode | React.ReactNode[];
    isActive?: boolean;
    backgroundColor?: string;
    isAlignedToTop?: boolean;
};

const GuidesToggleCard: React.FC<GuidesToggleCardProps> = (props) => {
    const componentRef = React.useRef<HTMLLIElement>(null);
    const { isActive, children, backgroundColor, isAlignedToTop } = props;
    const classname = cx({
        'guides-toggle-card': true,
        'is-aligned-to-top': isAlignedToTop,
        'is-active': isActive,
    });

    return (
        <li
            className={classname}
            ref={componentRef}
            style={{ backgroundColor }}
            aria-current={isActive ? 'page' : undefined}
        >
            {children}
        </li>
    );
};

export default GuidesToggleCard;
